const ITEMS = [
  "Hipertrofia",
  "Emagrecimento",
  "Dieta flexível",
  "Acompanhamento diário",
  "Periodização avançada",
  "Resultados reais",
];

const Row = ({ ariaHidden }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span
        key={item}
        className="flex items-center gap-8 px-8 font-display text-2xl font-bold uppercase tracking-tight text-black md:text-4xl"
      >
        {item}
        <span className="inline-block h-2 w-2 rotate-45 bg-black" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="marquee-band overflow-hidden border-y border-black bg-white py-4 md:py-5"
    >
      <div className="flex w-max animate-marquee">
        <Row ariaHidden={false} />
        <Row ariaHidden={true} />
      </div>
    </section>
  );
}
